{
  "helpMessage": "<h3>He pātai āu?</h3>\n<p>Kei konei mātou ki te āwhina – waea mai ki tā mātou tīma:<br/>\n<a><strong>☎️ {{phone}}</strong></a> (pēhia <strong>Kōwhiringa 2</strong>)<br/>\nRāhina ki Rāmere, 8am–5pm.</p>",
  "text": "<p>Mā mātou tō rata tuku ki te hōhipera e whakamōhio, ā, tērā pea ka whakapā mai rātou ki a koe ki te kōrero mō ngā mahi ka whai ake.</p>\n<p>Kāore he mahi anō māu i tēnei wā.</p>",
  "title": "Kua whakatau koe kia kaua e tono wā i tēnei wā."
}
